import { Injectable, InjectionToken, Inject, Injector } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/user-service';


@Injectable({
    providedIn: 'root',
})
export class HomeViewModel {
    userService: UserService = this.injector.get(UserService);

    constructor(private injector: Injector) {
    }

    // tslint:disable-next-line: new-parens
    public input = new class {
        public viewClick: Observable<any>;
        public submitClick: Observable<any>;
    };

    // tslint:disable-next-line: new-parens
    public output = new class {
        public userSubject = new Subject<User>();
    };

    setup(): boolean {
        let isSetUp = false;

        if (this.input.viewClick != null) {
            this.onViewClick();

            isSetUp = true;
        }

        return isSetUp;
    }

    onViewClick(): void {
        this.input.viewClick.subscribe((value) => {
            
            // console.log(value);
            // this.userService
            //     .getUserAPI()
            //     .subscribe((data) => {
            //         console.log(data);
            //         this.output.userSubject.next(data);
            //     });
        });

        this.input.submitClick.subscribe((user) => {
            console.log(user);
            //console.log(<RxFormGroup>this.form).modelInstanceValue)
        });
    }



}
